/**
 * HasBoughtConditionType - Condition qui vérifie si un achat a été fait
 * Identique à Flutter HasBoughtConditionType
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';

export class HasBoughtConditionType implements ConditionType {
  typeName = 'has_bought';
  messageKey = 'laventurier.condition.has-bought.name';
  descriptionKey = 'laventurier.condition.has-bought.desc';
  errorKey = 'laventurier.condition.has-bought.error';
  hasValue = false;
  hasAttribute = true;

  evaluate(gameState: GameState, condition: any): boolean {
    const attributeId = condition.attribute || condition.attributeId;
    if (!attributeId) {
      return false;
    }

    const typeName = attributeId.toString();
    const result = gameState.data.adventureExtraFields.some((e) => e.type === typeName);
    console.log(`[HasBoughtConditionType] ${result ? 'TRUE' : 'FALSE'}: ${typeName} found in adventureExtraFields`);
    return result;
  }
}
